enum EProtocols {
  HTTP = 'http',
  HTTPS = 'https',
}

export default EProtocols;
